module.exports = __webpack_public_path__ + "img/2038350.947e7d85.png";